import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=223832ee&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223832ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223832ee')) {
      api.createRecord('223832ee', component.options)
    } else {
      api.reload('223832ee', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=223832ee&scoped=true&", function () {
      api.rerender('223832ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dbpPba5pKXu4/JS/comp/Accordion.vue"
export default component.exports